interface MaintenancePageProps {
  showAdminButton: boolean;
  reEnablePageFunction: () => void;
  productIsDisabled: boolean;
}

export const MaintenancePage = (props: MaintenancePageProps) => {
  return (
    <div>
      {props.productIsDisabled && (
        <div className="status-banner">
          <span className="icon">⚠️</span>
          <strong>
            All boards seem to be experiencing issues right now. Please try
            again at a later time.
          </strong>
        </div>
      )}
      <div className="loading-div">
        <div>
          <img src="/Under-Maintenance.png" />
        </div>
        <div style={{ textAlign: "center" }}>
          This dashboard is under maintenance. Please try again later.
        </div>
        {props.showAdminButton && (
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                props.reEnablePageFunction();
              }}
            >
              Temporarily bypass block
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
